import { render, staticRenderFns } from "./EnrollmentNotification.vue?vue&type=template&id=84f14d3c&scoped=true&"
import script from "./EnrollmentNotification.vue?vue&type=script&lang=js&"
export * from "./EnrollmentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f14d3c",
  null
  
)

export default component.exports